<template>
  <div>
    <div class="menu-box">
      <div class="content-box menu">
        <div
          v-for="(item,index) in joins"
          :key="item.id"
          class="menu-item"
          :class="{'menu-active':index===activeIndex}"
          @click="menuClick(index)"
        >
          {{ item.type }}
          <div class="underline" />
        </div>
      </div>
    </div>
    <div class="content-box">
      <div class="box">
        <div class="left">
          <div class="join">Join us</div>
          <div class="line-box">
            <div class="line" />
            <div class="bar" />
          </div>
          <div class="join-content">{{ joins[activeIndex].intro }}</div>
          <div class="join addr">Address</div>
          <div class="line-box">
            <div class="line" />
            <div class="bar" />
          </div>
          <div>
            <p>Medical Science Building D108<br>Tsinghua University<br>Beijing, 100084, China</p>
            <p>Phones: 86-010-6279-8513</p>
            <p>Email: xshen@tsinghua.edu.cn</p>
          </div>
        </div>
        <div class="right">
          <baidu-map
            class="bmap"
            :center="lnglat"
            :zoom="17"
            :scroll-wheel-zoom="true"
            ak="2b866a6daac9014292432d81fe9b47e3"
          >
            <bm-marker :position="lnglat" @click="infoWindowOpen">
              <bm-info-window :show="infoShow" @close="infoWindowClose" @open="infoWindowOpen">
                <div class="info-box">
                  <div style="font-weight: 500">X.shen Lab</div>
                  <div>地址：清华大学郑裕彤医学楼xxx X.Shen Lab E000</div>
                </div>
              </bm-info-window>
            </bm-marker>
          </baidu-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BaiduMap, BmMarker, BmInfoWindow } from 'vue-baidu-map'

export default {
  name: 'Join',
  components: {
    BaiduMap,
    BmMarker,
    BmInfoWindow
  },
  data() {
    return {
      joins: [],
      activeIndex: 0,
      lnglat: { lng: 116.324886, lat: 40.009734 },
      infoShow: false
    }
  },
  created() {
    this.$axios.get(this.$api.listJoin).then(res => {
      this.joins = res.data
    })
  },
  methods: {
    menuClick(index) {
      this.activeIndex = index
    },
    infoWindowClose() {
      this.infoShow = false
    },
    infoWindowOpen() {
      this.infoShow = true
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu-box
  width 100%
  margin-top 40px
  background white
  height 120px
  font-size 24px
  color rgba(46, 62, 106, 1)
  .menu
    display flex
    justify-content space-between
    height 120px
    line-height 118px

    .menu-item
      cursor pointer
      position relative
      flex 1
      text-align center

    .menu-active
      font-weight 600

      .underline
        width 100%
        position absolute
        bottom 0
        height 5px
        background rgba(46, 62, 106, 1)
.box
  display flex
  justify-content space-between
  align-items stretch
  margin 40px 0 50px 0
  .left
    width 49.8%
    color white
    font-size 14px
    background linear-gradient(136deg,rgba(77,97,161,1) 0%,rgba(39,55,94,1) 100%,rgba(48,64,91,1) 100%)
    padding 20px 33px 10px 29px
    box-sizing border-box
    display flex
    flex-direction column
    justify-content center
    .join
      font-size 26px
      font-weight 500
      margin-bottom 12px
    .line-box
      width 100%
      position relative
      margin-bottom 20px
      .line
        width 100%
        height 1px
        background white
        opacity 0.2
      .bar
        width 50px
        height 5px
        background rgba(203, 214, 255, 1)
        border-radius 0 71px 0 0
        position absolute
        bottom 1px
        opacity 1.0
    .join-content
      white-space pre-wrap
    .addr
      margin-top 30px
  .right
    min-height 600px
    width 48.5%
    .bmap
      width 100%
      height 100%
    .info-box
      width 286px
      font-size 16px
      color rgba(50,50,50,1)
</style>
